<template>
  <div class="container">
    <div class="head">
      <div class="headline">Votre compte client</div>
      <div class="subline">Accès applications</div>
    </div>
    <div class="main">
      <LoggedNav class="side-nav" :userInfos="userInfos"/>
      <div class="demos">
        <div>
          <AccessDAP :products="products"/>
        </div>
        <div>
          <AccessECA :products="products"/>
        </div>
        <div>
          <AccessFleet :app="apps?.find((app) => app.app == 'Fleet')"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, onMounted } from "vue";
import { useRouter } from "vue-router";
import UserService from "../../services/UserService";
import LoggedNav from "../../components/LoggedComp/LoggedNav";
import AccessDAP from "../../components/LoggedComp/AccessDAP";
import AccessECA from "../../components/LoggedComp/AccessECA";
import AccessFleet from "../../components/LoggedComp/AccessFleet";

import { useToast } from "vue-toastification";
export default {
  components: {
    AccessFleet,
    AccessDAP,
    LoggedNav,
    AccessECA,
  },
  setup() {
    const toast = useToast();

    const router = useRouter();

    const userInfos = ref("");
    const products = ref("");
    const apps = ref([]);

    const getData = async (token) => {
      const data = await UserService.me(token);
      const productList = await UserService.products(token);
      const appList = await UserService.apps(token);
      if (data.infos == null) {
        localStorage.removeItem("token");
        router.push("/private");
        toast("Une erreur est survenue");
      }
      userInfos.value = data.infos;
      products.value = productList.apps;
      apps.value = appList.appList
    };

    onMounted(async () => {
      const token = localStorage.getItem("token");
      if (token == null || token.length == 0) {
        localStorage.removeItem("token");
        router.push("/private");
      }
      await getData(token);
    });

    return {
      userInfos,
      products,
      apps,
    };
  },
};
</script>

<style lang="scss" scoped>
.container {
  display: flex;
  flex-direction: column;
  widows: 100%;
  .head {
    .headline {
      font-size: 30px;
      margin-top: 50px;
      font-weight: 700;
    }
    .subline {
      font-size: 20px;
      color: var(--mainGreen);
      margin-bottom: 50px;
    }
  }
  .main {
    display: flex;
    flex-direction: row;
    .demos {
      display: flex;
      flex-direction: column;
      width: 100%;
    }
    .side-nav{
      min-width: 23%;
      max-width: 23%;
    }
  }
}

.side-nav {
  margin-right: 2rem;
  .panel-info {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    border-radius: 5px;
    // box-shadow: 1px 1px 5px rgba($color: #000000, $alpha: 0.3);
    box-shadow: rgba(0, 0, 0, 0.16) 0px 1px 4px;
    padding: 1em;
    margin-bottom: 1em;
    .user-company {
      font-weight: bolder;
      text-transform: capitalize;
    }
    .logout-button {
      color: white;
      width: 100%;
      padding: 1em;
      margin-top: 1em;
      background-color: var(--mainBlue);
      border: none;
      font-size: 1em;
      font-weight: bolder;
      text-transform: uppercase;
    }
  }
  .contact {
    padding: 1em;
    border-radius: 5px;
    // box-shadow: 1px 1px 5px rgba($color: #000000, $alpha: 0.3);
    box-shadow: rgba(0, 0, 0, 0.16) 0px 1px 4px;
    .headline {
      font-weight: bolder;
    }
  }
  .card {
    border: none;
  }
}
</style>